import moment from "moment";
import { useLocale } from "@lib/i18n/navigation-pages-router";

export function useFormatDate() {
  const locale = useLocale();

  return (date) => {
    if (!locale || date == null) return null;

    // parseZone keeps the offset embedded in the string (e.g. Chronopost's +02:00) instead of
    // converting to the browser's timezone, so the displayed calendar day never shifts.
    const m = typeof date === "string" ? moment.parseZone(date) : moment(date);
    if (!m.isValid()) return null;

    switch (locale) {
      case "en":
        return m.format("MM/DD/YYYY");
      default:
        return m.format("DD/MM/YYYY");
    }
  };
}
